import IsAction from './IsAction'

export default IsAction
